import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_success_box = _resolveComponent("success-box")!
  const _component_error_box = _resolveComponent("error-box")!
  const _component_AlertBox = _resolveComponent("AlertBox")!
  const _component_DecoinsLimitModal = _resolveComponent("DecoinsLimitModal")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_success_box, { success: _ctx.success }, null, 8, ["success"]), [
      [_vShow, _ctx.success]
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_error_box, {
          key: 0,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    (_ctx.isAlertBoxOpen)
      ? (_openBlock(), _createBlock(_component_AlertBox, { key: 1 }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentListPickerModal))),
    (_ctx.isVisibleDecoinsModalLimit)
      ? (_openBlock(), _createBlock(_component_DecoinsLimitModal, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 3,
          message: _ctx.loadingMessage
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ], 64))
}